import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  ref,
  reactive,
  inject,
  onMounted,
  watch,
  getCurrentInstance,
} from "vue";
import type { FormInstance, FormRules } from "element-plus";
import { getQrCode, getQrInfo, getPhoneCode, loginPhone } from "@/api/login";
import { permutationToken } from "@/api/exibition";
import { fa } from "element-plus/es/locale";
import { userStore } from "@/stores/modules/user";
import { ElMessage, ElLoading } from "element-plus";


import { defineComponent } from "vue";
import Header from "@/layout/header.vue";
import Login from "@/layout/login.vue";
import Experience from "./index/experience.vue";
import Flowpath from "./index/flowPath.vue";
import Tree from "./index/tree.vue";
import Marketing from "./index/marketing.vue";
import MeetingAffairs from "./index/meetingAffairs.vue";
import ProductWhy from "./index/productWhy.vue";
import Footer from "./index/footer.vue";

const __default__ = defineComponent({
  name: "homeView",
  components: {
    Header,
    Experience,
    Flowpath,
    Tree,
    Marketing,
    MeetingAffairs,
    ProductWhy,
    Footer,
    Login,
  },
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const visible = ref(false);
const userState = userStore();
const changeShow = (e: any) => {
  visible.value = e;
};
const newTime = ref(new Date().getTime());

// 获取链接参数
const getQueryString = (url: string) => {
  let ItemArr: any = [];
  let ItemObj: object = {};
  url
    .substring(url.lastIndexOf("?") + 1, url.length)
    .split("&")
    .map((item: any) => {
      ItemArr.push(item.split("="));
    });
  ItemArr.map((item: any) => {
    ItemObj[item[0]] = item[1];
  });
  return ItemObj;
};

const getToken = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const paramValue = urlParams.get("center_token");
  console.log(paramValue);
  if (paramValue) {
    displaceToken(paramValue);
  }
};
const displaceToken = (_token: any) => {
  let data = {
    token: _token,
  };
  permutationToken(data).then((res) => {
    userState.setUserInfo(res.data);
    userState.setToken(res.data.token);
    refreshPage();
  });
};
const refreshPage = () => {
  const url = window.location.href;
  const baseUrl = url.split("?")[0];
  history.replaceState({}, document.title, baseUrl);
  location.reload();
};
getToken();
const getUserInfo = () => {
  let url: any = decodeURIComponent(location.href);
  if (getQueryString(url).userInfo) {
    let info = JSON.parse(getQueryString(url).userInfo);
    userState.login(info);
  }
};
getUserInfo();
const loginDialog = (data: boolean) => {
  visible.value = true;
};
const loginOut = (data: any) => {
  newTime.value = data;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header, {
      onLoginDialog: loginDialog,
      onLoginOut: loginOut
    }),
    _createVNode(Experience),
    _createVNode(Flowpath),
    _createVNode(Tree),
    _createVNode(Marketing),
    _createVNode(MeetingAffairs),
    _createVNode(ProductWhy),
    _createVNode(Footer),
    _createVNode(Login, {
      showLogin: visible.value,
      onChangeShow: changeShow
    }, null, 8, ["showLogin"])
  ]))
}
}

})